import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'normalize.css/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet/dist/leaflet.css';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HashRouter, Routes, Route } from 'react-router-dom';

import ContainerPlots from './containers/container-plots';
import { LanguageStateProvider, initialStateEnglish, initialStateFrench } from './contexts/language-state-provider';
import { AppStateProvider, initialStateProduction } from './contexts/app-state-provider';

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <LanguageStateProvider initialState={(document.documentElement.lang === 'fr') ? initialStateFrench : initialStateEnglish}>
        <AppStateProvider initialState={initialStateProduction}>
          <Routes>
            <Route path="/" element={<App />}>
              <Route path="/:sncl" element={ <ContainerPlots /> } />
            </Route>
          </Routes>
        </AppStateProvider>
      </LanguageStateProvider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
